import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { Quotation } from "./QuotationData";

export function makeBasePortFieldSpecs(): FilterField<Quotation>[] {
  return [
    {
      label: "Service ID",
      key: "serviceid",        
      accessor: (r) => r.serviceId,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    // Filter on the **label** users expect.
    {
      label: "Status",
      key: "status",
      accessor: (r) => {
        const s = r.status;
        if (s === "up") return "Active";
        if (s === "down") return "Down";
        return "Unknown";
      },
      type: "string",
      inFreeText: true,
    },
    {
      label: "Tag",
      key: "tag",
      accessor: (r) => (r.tag?.length ? r.tag.join(" ") : ""),
      type: "string",
      inFreeText: true,
    },
  ];
}

export function makeQuotationFields(
  isViewingAllCustomers: boolean
): FilterField<Quotation>[] {
  const base = makeBasePortFieldSpecs();
  if (isViewingAllCustomers) {
    base.splice(1, 0, {
      label: "Customer",
      key: "customer",
      accessor: (r) => [
        r.customer?.name ?? "",
        r.customer?.chargebeeCustomerId ?? ""
      ].filter(Boolean).join(" "),
      type: "string",
      inFreeText: true,
    });
  }
  // Ensure keys
  for (const f of base) f.key ||= labelId(f.label);
  return base;
}
